import React, { useRef, useContext, useEffect } from 'react'
import ApplicationContext from '../../utility/ContextProvider'
import './NavigationMenuButton.scss'

interface NavigationMenuButtonProps {
  setNavigationOpen: any
  navigationOpen: any
}

function NavigationMenuButton({ setNavigationOpen, navigationOpen }: NavigationMenuButtonProps) {
  const { darkMode } = useContext(ApplicationContext)

  const lineOneRef = useRef(null)
  const lineTwoRef = useRef(null)

  useEffect(() => {
    if (darkMode && navigationOpen) {
      lineOneRef.current.style.background = '#050505'
      lineTwoRef.current.style.background = '#050505'
    }

    if (darkMode && !navigationOpen) {
      lineOneRef.current.style.background = '#e4e6eb'
      lineTwoRef.current.style.background = '#e4e6eb'
    }

    if (!darkMode && navigationOpen) {
      lineOneRef.current.style.background = '#e4e6eb'
      lineTwoRef.current.style.background = '#e4e6eb'
    }

    if (!darkMode && !navigationOpen) {
      lineOneRef.current.style.background = '#050505'
      lineTwoRef.current.style.background = '#050505'
    }
  }, [darkMode, navigationOpen])

  return (
    <div className='navigationMenuButton' onClick={() => setNavigationOpen(lineOneRef, lineTwoRef)}>
      <div className='navigationMenuButton__line navigationMenuButton__line__one' ref={lineOneRef}></div>
      <div className='navigationMenuButton__line navigationMenuButton__line__two' ref={lineTwoRef}></div>
    </div>
  )
}

export default NavigationMenuButton
